import styled from 'src/utils/styled/styled';
import { siteColors } from 'src/constants/themes';

export const DialogHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${siteColors.primary};
  padding: 4px;
`;

export const XButton = styled.button`
  background-color: ${siteColors.primary};
  border: none;
  color: white;
  font-size: 1.2rem;
`;

export const CloseButton = styled.button`
  background-color: white;
  border: none;
  color: black;
  font-size: 1.2rem;
`;

export const Drawer = styled.div`
  width: 256px;
  flex-shrink: 0;
  top: 0;
  flex: 1 0 auto;
  height: 100%;
  display: flex;
  outline: 0;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;